import React from "react";

export default function RightPanelHeader({
  logoSrc,
  logoAlt = "logo",
  brand = "",           // logoSrc가 없을 때 텍스트 표시
  onClose = () => { },
  height = 48,
  style = {},
  className = "",
}) {
  const base = {
    height,
    padding: "8px 12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #e5e7eb",
    background: "rgba(255,255,255,0.9)",
    backdropFilter: "blur(6px)",
    WebkitBackdropFilter: "blur(6px)",
  };

  return (
    <div
      className={className}
      style={{ ...base, ...style, paddingTop: `calc(8px + env(safe-area-inset-top, 0px))` }}
    >
      {/* Left: Logo or Brand text */}
      <div style={{ display: "flex", alignItems: "center", minWidth: 0 }}>
        {logoSrc ? (
          <>  
          <img
            src={logoSrc}
            alt={logoAlt}
            style={{ height: height - 20, width: "auto", display: "block" }}
          />
          <div style={{fontWeight: 700, fontSize: 18, padding: "8px 10px", textAlign: "left"}}>S-100 기반의 스마트선박용 수로정보</div>
          </>
        ) : (
          <span
            style={{
              fontSize: 16,
              fontWeight: 700,
              letterSpacing: 0.2,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            title={brand}
          >
            {brand || "Brand"}
          </span>
        )}
      </div>
      
    

      {/* Right: Close button */}
      <button
        type="button"
        onClick={onClose}
        aria-label="패널 닫기"
        title="닫기"
        style={{
          height: 32,
          width: 32,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 8,
          border: "1px solid rgba(0,0,0,0.1)",
          background: "white",
          cursor: "pointer",
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") onClose();
          if (e.key === "Escape") onClose();
        }}
      >
        {/* X 아이콘 (SVG) */}
        <svg
          width="16" height="16" viewBox="0 0 24 24" aria-hidden="true"
          style={{ display: "block", opacity: 0.8 }}
        >
          <path
            d="M18 6L6 18M6 6l12 12"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </button>
    </div>
  );
}
